'use client';

export default function ServiceUnavailable({
  fullScreen = false,
  detail,
}: {
  fullScreen?: boolean;
  detail?: string;
}) {
  return (
    <div
      className={`flex items-center justify-center bg-base-100 ${fullScreen ? 'h-screen' : 'h-full'}`}
    >
      <div className="max-w-md text-center">
        <h1 className="mb-4 text-xl font-semibold text-base-content">
          Connection to Chronos was lost
        </h1>
        <p className="mb-6 text-sm text-base-content/70 whitespace-pre-line">
          {detail ??
            'An update may be in progress. Hang tight and try again shortly.\n' +
              "If the connection isn't restored, please check that you are connected to the VPN or the office WiFi."}
        </p>
        <button onClick={() => window.location.reload()} className="btn btn-primary btn-sm">
          Retry
        </button>
      </div>
    </div>
  );
}
